import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TranslateDirective } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { PermissionName } from '@app/core/permissions/enums/permission-name.enum';

@Component({
  selector: 'gc-comment-card-no-data',
  templateUrl: './comment-card-no-data.component.html',
  styleUrl: './comment-card-no-data.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, ButtonModule, TranslateDirective, NgxPermissionsModule],
})
export class CommentCardNoDataComponent {
  public showBorder = input<boolean>(true);
  public addPermissions = input<PermissionName[]>([]);

  public add = output<void>();
}
